<template>
  <div class="pc-holder-info">
    <div class="select-box">
      <span>{{holderInfo.symbol}}代币持有者</span>
      <i class="iconfont iconshaixuan"></i>
      <label>范围</label>
      <el-select
        v-model="num"
        placeholder="请选择"
        size="mini"
        class="holder-range"
        @change="selectRange"
      >
        <el-option label="最佳 10" :value="10"></el-option>
        <el-option label="最佳 20" :value="20"></el-option>
        <el-option label="最佳 30" :value="30"></el-option>
      </el-select>
    </div>
    <div class="chart-container table-shadow">
      <div class="head flex-center">
        <span class="flex-left">
          <i class="iconfont iconyonghu"></i>
          最佳{{num}}持有人总拥有{{(holdTotal*100/holderInfo.total).toFixed(2)}} %（{{holdTotal/100000000}} 代币）的BTY
        </span>
        <span class="flex-left">
          <i class="iconfont iconjiangzhang"></i>
          代币总供应量：{{(holderInfo.total/100000000)|filterNum}} 代币 丨 总共代币持有人：{{holderInfo.holders}}
        </span>
      </div>
      <div class="hold-chart" id="myChart"></div>
      <div
        class="tip"
      >注：最佳{{num}}账户所持有的总共 {{(holdTotal/100000000).toFixed(4)}} 代币是来自 {{(holderInfo.total/100000000)|filterNum}} 代币的总供应量</div>
    </div>
  </div>
</template>

<script>
import HolderInfoBase from "@/mixins/Holder/holderInfo.js";
export default {
  mixins: [HolderInfoBase]
};
</script>

<style lang="scss" scoped>
.pc-holder-info {
  .select-box {
    margin-bottom: 10px;
    span {
      font-size: 16px;
      font-family: PingFangSC-Semibold;
      font-weight: 500;
      color: $black;
    }
    i {
      margin-left: 30px;
      color: $grey_deep;
    }
    label {
      margin: 0 14px 0 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: $black;
    }
    .holder-range {
      width: 105px;
    }
  }
  .chart-container {
    height: 426px;
    background: $white;
    border-radius: 2px;
    border: 1px solid rgba(235, 239, 241, 1);
    .head {
      height: 53px;
      border-bottom: 1px solid #eee;
      span {
        width: 50%;
        height: 100%;
        padding-left: 85px;
        color: $black;
        font-size: 14px;
        i {
          margin-right: 8px;
          color: #9aaab9;
          font-size: 18px;
        }
      }
      span:first-child {
        border-right: 1px solid #ebeff1;
      }
    }
    .hold-chart {
      height: 315px;
    }
    #holder-pie {
      height: 100%;
      width: 100%;
    }
    .tip {
      padding-left: 94px;
      line-height: 58px;
      font-size: 12px;
      font-weight: 400;
      color: $font_grey;
    }
  }
}
</style>
